import { render, staticRenderFns } from "./BalanceData.vue?vue&type=template&id=708803cf&scoped=true&"
import script from "./BalanceData.vue?vue&type=script&lang=js&"
export * from "./BalanceData.vue?vue&type=script&lang=js&"
import style0 from "./BalanceData.vue?vue&type=style&index=0&id=708803cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708803cf",
  null
  
)

export default component.exports